// extracted by mini-css-extract-plugin
module.exports = {"entry":"NewComment_entry__1Fp2-","profilePicture":"NewComment_profilePicture__3uWFg","commentBody":"NewComment_commentBody__QXhHn","submitButton":"NewComment_submitButton__3NU8R"};